<template>
    <div class="qrcode">
        <template v-if="!!url">
            <img :src="previewQrCode" alt="#" class="qrcode__img">

            <div v-if="showDownload || showPrint" class="qrcode__buttons">
                <button v-if="showDownload" class="btn qrcode__button" type="button" @click="getMyQrcode(queryParams)">
                    <svg width="17" height="17">
                        <use xlink:href="/assets/front/img/sprite.svg#icon-download"></use>
                    </svg>
                </button>

                <a v-if="windowWidth > 1200 && showPrint" class="btn qrcode__button" target="_blank" :href="printQrcode">
                    <svg width="17" height="17">
                        <use xlink:href="/assets/front/img/sprite.svg#icon-print"></use>
                    </svg>
                </a>
            </div>
        </template>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: "QrCodePreview",
    props: {
        link: {
            type: String,
            default: ''
        },
        withProject: {
            type: Boolean,
            default: true
        },
        withLatinProject: {
            type: Boolean,
            default: false
        },
        previewWithoutProject: {
            type: Boolean,
            default: false
        },
        showPrint: {
            type: Boolean,
            default: true
        },
        showDownload: {
            type: Boolean,
            default: true
        }
    },
    data: () => ({
        url: ''
    }),
    computed: {
        printQrcode() {
            return this.addParams(window.laravel.appUrlByLocale + "/qrcode-print");
        },
        previewQrCode() {
            return this.addParams(window.laravel.appUrlByLocale + "/qrcode-preview", !this.previewWithoutProject);
        },
        queryParams() {
            return this.getQueryParams(this.withProject);
        }
    },
    methods: {
        ...mapActions('cabinet', [
            'getMyQrcode'
        ]),
        addParams(url, withProject = true) {
            return url + '?' + (new URLSearchParams(this.getQueryParams(withProject)))
        },
        getQueryParams(withProject) {
            let params = { url: this.url };

            if (withProject) {
                params.withProject = withProject;
            }

            if (this.withLatinProject) {
                params.withLatinProject = this.withLatinProject;
            } else if (window.laravel.locale !== 'ru') {
                params.withLatinProject = true;
            }

            return params
        }
    },
    mounted() {
        this.url = this.link;

        this.$on('generateQrCode', (url) => {
            this.$set(this, 'url', url);
        });

        window.addEventListener('resize', () => {
            this.windowWidth = window.innerWidth;
        });
    }
}
</script>
